import React from 'react'
import ReactDOM from 'react-dom'
import { createApp } from './App'
import { getModel } from './data/Model'
import { Toaster } from 'sonner'

export let renderApp = () => {}
;(async () => {
	const App = await createApp()

	renderApp = () => {
		ReactDOM.render(
			<div>
				<App model={getModel()} />
				<Toaster />
			</div>,
			document.getElementById('root'),
		)
	}
	renderApp()

	// Unregister service worker to prevent caching
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.getRegistrations().then((registrations) => {
			registrations.forEach((registration) => {
				registration.unregister()
			})
		})
	}
})()
